import { isDefined } from "../../../helper/utils";
import ValidationService from "../../../services/ValidationService";
import TranslationService from "../../../services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";
import CreateUpdateAddress from "./CreateUpdateAddress/CreateUpdateAddress";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";

const ApiService = require("../../../services/ApiService");
const ModalService = require("../../../services/ModalService");

export default Vue.component("address-select", {

    template: `
        <div>
            <div class="cmp cmp-address-list mb-4">
                <div class="dropdown items">
                    <div
                        class="component-loading"
                        :id="'addressMultiSelect' + _uid"
                        :class="{ 'card': !isAddressListEmpty && !(addressType === '2' && addressList.length === 1), 'items items-empty': isAddressListEmpty && (addressType === '2' && addressList.length === 1), 'is-loading disabled': isBasketLoading || isCheckoutReadonly }"
                        @click="onDropdownClicked($event)"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        data-boundary="window"
                        data-flip="false"
                        ref="dropdown">

                        <div class="item-inner" :class="{ 'error': showError }">
                            <div v-if="selectedAddress && selectedAddress.id == -99">
                                <p class="text-muted small font-italic pt-3 m-0" :class="paddingClasses" :style="paddingInlineStyles">{{ $translate('Ceres::Template.addressSameAsInvoice') }}</p>
                            </div>
                            <div v-else class="item-content">
                                <div v-if="!isAddressListEmpty && selectedAddress">
                                    <address-header :address="selectedAddress" :class="paddingClasses" :style="paddingInlineStyles"></address-header>
                                </div>
                                <p v-if="!isAddressListEmpty && !selectedAddress" class="text-muted small font-italic pt-3">{{ $translate('Ceres::Template.addressPleaseSelect') }}</p>
                                <p v-if="isAddressListEmpty" class="text-muted small font-italic pt-3">{{ $translate('Ceres::Template.addressNoAddress') }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="add-item">
                        <button
                            v-tooltip
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="$translate('Ceres::Template.addressAddAddressTooltip')"
                            class="btn btn-primary btn-appearance btn-large btn-only-icon-xs-down d-block"
                            v-if="isAddAddressEnabled"
                            @click.prevent="showAddModal()"
                            :disabled="isBasketLoading || isCheckoutReadonly"
                            :data-testing="addressTypePrefix + 'address-select-add'">
                            <span>{{ $translate('Ceres::Template.addressAddAddress') }}</span>
                            <i class="fa fa-plus-square" aria-hidden="true"></i>
                        </button>

                        <button
                            v-tooltip
                            data-toggle="tooltip"
                            data-placement="bottom"
                            @click="toggleDropdown($event)"
                            :title="$translate('Ceres::Template.addressChangeTooltip')"
                            class="btn btn-primary btn-appearance btn-large btn-only-icon-xs-down mt-2 d-block"
                            v-if="shouldShowEditAddressButton"
                            :disabled="isBasketLoading || isCheckoutReadonly"
                            :data-testing="addressTypePrefix + 'address-select-open'">
                            <span>{{ $translate('Ceres::Template.addressChange') }}</span>
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div
                        class="dropdown-menu"
                        :aria-labelledby="'addressMultiSelect' + _uid"
                        :data-testing="addressTypePrefix + 'address-select-dropdown'">
                        <ul v-if="!isAddressListEmpty && !(addressType === '2' && addressList.length === 1)">
                            <DynamicScroller
                                class="virtual-scroller"
                                :items="addressList"
                                :min-item-size="115"
                                key-field="id">
                                <template v-slot="{ item, index, active }">
                                    <DynamicScrollerItem
                                        :item="item"
                                        :active="active"
                                        :data-index="index"
                                        :watch-data="true">
                                        <li class="item">
                                            <input
                                                type="radio"
                                                :name="'shippingAddress' + _uid"
                                                :id="'addressSelectItem' + _uid + item.id"
                                                :value="item.id"
                                                :checked="selectedAddress && selectedAddress.id === item.id"
                                                @change="onAddressChanged(item)">
                                            <label :for="'addressSelectItem' + _uid + item.id" class="item-inner">
                                                <div v-if="item.id == -99">
                                                    <p class="text-muted small font-italic pt-3">{{ $translate('Ceres::Template.addressSameAsInvoice') }}</p>
                                                </div>
                                                <div v-else class="item-content small">
                                                    <address-header :address="item" :class="paddingClasses" :style="paddingInlineStyles"></address-header>
                                                </div>
                                                <div class="item-controls" v-if="item.id != -99">
                                                    <span class="item-edit ml-auto">
                                                        <button
                                                            v-tooltip
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            :title="$translate('Ceres::Template.addressEditTooltip')"
                                                            class="btn btn-primary btn-medium btn-appearance mr-1"
                                                            @click.prevent="showEditModal(item)"
                                                            :data-testing="addressTypePrefix + 'address-select-edit'">
                                                            <span class="d-none d-lg-inline-block">{{ $translate('Ceres::Template.addressEdit') }}</span>
                                                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                        </button>
                                                    </span>
                                                    <span class="item-remove">
                                                        <button
                                                            v-tooltip
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            :title="$translate('Ceres::Template.addressDelete')"
                                                            class="btn btn-danger"
                                                            @click.prevent="showDeleteModal(item)"
                                                            :data-testing="addressTypePrefix + 'address-select-remove'">
                                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </label>
                                        </li>
                                    </DynamicScrollerItem>
                                </template>
                            </DynamicScroller>
                        </ul>
                    </div>
                </div>
            </div>

            <div ref="addressModal">
                <div class="modal fade" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ headline }}</h4>
                                <button type="button" class="close" @click="closeAddressModal" :aria-label="$translate('Ceres::Template.closeIcon')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div class="modal-body">
                                <fieldset>
                                    <create-update-address
                                        template="#vue-create-update-address"
                                        :address-data="addressToEdit"
                                        :address-modal="addressModal"
                                        :modal-type="modalType"
                                        :address-type="addressType"
                                        @input="setAddressToEditField($event)"
                                        :optional-address-fields="optionalAddressFields"
                                        :required-address-fields="requiredAddressFields"
                                        :default-salutation="defaultSalutation">
                                    </create-update-address>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div ref="deleteModal" :data-testing="addressTypePrefix + 'address-select-remove-modal'">
                <div class="modal fade" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ headline }}</h4>
                                <button type="button" class="close" @click="closeDeleteModal" :aria-label="$translate('Ceres::Template.closeIcon')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div class="modal-body" :data-testing="addressTypePrefix + 'address-select-remove-modal-body'">
                                <fieldset>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="modal-address">
                                                <strong v-if="addressToDelete.name1 && addressToDelete.name1.length > 0">{{ addressToDelete.name1 }}</strong>
                                                <strong v-if="!addressToDelete.name1 || addressToDelete.name1.length == 0">{{ addressToDelete | optionType(11) }} {{ addressToDelete.name2 }} {{ addressToDelete.name3 }}</strong>
                                                <span v-else>{{ selectedAddress | optionType(11) }} {{ addressToDelete.name2 }} {{ addressToDelete.name3 }}</span>
                                                <span>{{ addressToDelete.name4 }}</span>
                                                <span>{{ addressToDelete.address1 }} {{ addressToDelete.address2 }}</span>
                                                <span>
                                                    <template v-if="addressToDelete.address1 === 'PACKSTATION' || addressToDelete.address1 === 'POSTFILIALE'">
                                                        {{ $translate('Ceres::Template.addressPostNummer') }}
                                                        {{ addressToDelete | optionType(6) }}
                                                    </template>
                                                    {{ addressToDelete.address3 }}
                                                </span>
                                                <span>{{ addressToDelete.postalCode }} {{ addressToDelete.town }}</span>
                                                <span>{{ getCountryName(addressToDelete.countryId) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                            <div class="modal-footer" :data-testing="addressTypePrefix + 'address-select-remove-modal-footer'">
                                <button
                                    type="button"
                                    class="btn btn-medium mr-2 btn-primary"
                                    @click="closeDeleteModal"
                                    :data-testing="addressTypePrefix + 'address-select-remove-modal-cancel'">
                                    <span>{{ $translate('Ceres::Template.addressCancel') }}</span>
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-danger btn-medium"
                                    :disabled="deleteModalWaiting"
                                    @click="deleteAddress"
                                    :data-testing="addressTypePrefix + 'address-select-remove-modal-remove'">
                                    <span>{{ $translate('Ceres::Template.addressDelete') }}</span>
                                    <icon icon="trash" :loading="deleteModalWaiting"></icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cmp-method-list mb-4" v-if="addressType == '2' && isInvalidShippingCountry && !isShopBuilder && isCheckoutTemplate">
                <div class="method-list-item has-error w-100">
                    <div class="label">
                        <div class="content" data-testing="message-invalid-shipping-country">
                            {{ $translate('Ceres::Template.checkoutInvalidShippingCountryGeoblocking') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,

    components:
    {
        CreateUpdateAddress,
        DynamicScroller,
        DynamicScrollerItem
    },

    props:
    {
        template:
        {
            type: String,
            default: "#vue-address-select"
        },
        addressType:
        {
            type: String,
            required: true
        },
        showError: Boolean,
        optionalAddressFields:
        {
            type: Object,
            default: () =>
            {
                return {
                    de: [],
                    gb: []
                };
            }
        },
        requiredAddressFields:
        {
            type: Object,
            default: () =>
            {
                return {};
            }
        },
        defaultSalutation:
        {
            type: String,
            default: App.config.addresses.defaultSalutation
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        email: String,
        isInvalidShippingCountry: {
            type: Boolean,
            default: false
        }
    },

    data()
    {
        return {
            addressModal   : {},
            modalType      : "",
            headline       : "",
            addressToEdit  : {
                gender: this.defaultSalutation,
                countryId        : this.shippingCountryId
            },
            addressToDelete: {},
            deleteModal    : "",
            deleteModalWaiting: false,
            addressOptionTypeFieldMap:
            {
                1: "vatNumber",
                4: "telephone",
                5: "email",
                6: "postNumber",
                9: "birthday",
                11: "title",
                12: "contactPerson"
            },
            isShopBuilder: App.isShopBuilder
        };
    },

    computed:
    {
        selectedAddress()
        {
            return this.$store.getters.getSelectedAddress(this.addressType);
        },

        addressList()
        {
            return this.$store.getters.getAddressList(this.addressType);
        },

        shippingCountryId()
        {
            return this.$store.state.localization.shippingCountryId;
        },

        isAddAddressEnabled()
        {
            if (this.addressType === "1")
            {
                return this.$store.getters.isLoggedIn || this.addressList.length < 1;
            }

            return this.$store.getters.isLoggedIn || this.addressList.length < 2;
        },

        isAddressListEmpty()
        {
            return !(this.addressList && this.addressList.length > 0);
        },

        isSalutationEnabled()
        {
            const countryId = parseInt(this.addressToEdit.countryId) || 1;
            const addressKey = parseInt(this.addressType) === 1 ? "billing_address" : "delivery_address";
            const countryKey = countryId === 12 ? "gb" : "de";

            return this.optionalAddressFields[countryKey].includes(`${addressKey}.salutation`);
        },

        shouldShowEditAddressButton()
        {
            // filters addresses like "Same as billing address"
            const realAddressList = this.addressList?.filter((address) => address.id >= 0);

            return realAddressList && realAddressList.length > 0;
        },

        addressTypePrefix()
        {
            return parseInt(this.addressType) === 1 ? "billing-" : "delivery-";
        },

        isCheckoutTemplate()
        {
            return typeof App !== "undefined" && App.templateType === "checkout";
        },

        ...mapState({
            countryList: state => state.localization.shippingCountries,
            isBasketLoading: state => state.basket.isBasketLoading,
            isCheckoutReadonly: state => state.checkout.readOnly
        })
    },

    /**
     *  Check whether the address list is not empty and select the address with the matching ID
     */
    created()
    {
        this.addEventListener();
    },

    /**
     * Select the address modal
     */
    mounted()
    {
        this.$nextTick(() =>
        {
            this.addressModal = ModalService.findModal(this.$refs.addressModal);
            this.deleteModal = ModalService.findModal(this.$refs.deleteModal);
        });
    },

    methods: {
        /**
         * Add the event listener
         */
        addEventListener()
        {
            ApiService.listen("AfterAccountContactLogout", () =>
            {
                this.$store.commit("resetAddress", this.addressType);
            });
        },

        /**
         * Update the selected address
         * @param index
         */
        onAddressChanged(address)
        {
            this.$emit("address-changed", address);
        },

        /**
         * Show the add modal
         */
        showAddModal(type)
        {
            this.modalType = type || "create";

            if (this.isSalutationEnabled)
            {
                this.addressToEdit = {
                    gender: this.defaultSalutation,
                    countryId: this.shippingCountryId,
                    showPickupStation: false,
                    email: this.email
                };
            }
            else
            {
                this.addressToEdit = { countryId: this.shippingCountryId, email: this.email };
            }

            this.updateHeadline();

            if (this.modalType === "create")
            {
                ValidationService.unmarkAllFields($(this.$refs.addressModal));
            }

            this.addressModal.show();
        },

        /**
         * Show the edit modal
         * @param address
         */
        showEditModal(address)
        {
            this.modalType = "update";
            this.addressToEdit = this.getAddressToEdit(address);

            if (isDefined(this.addressToEdit.address1) && (this.addressToEdit.address1 === "PACKSTATION" || this.addressToEdit.address1 === "POSTFILIALE") && this.$store.getters.isParcelOrOfficeAvailable)
            {
                this.addressToEdit.showPickupStation = true;
            }

            this.updateHeadline();
            ValidationService.unmarkAllFields($(this.$refs.addressModal));
            this.addressModal.show();
        },

        getAddressToEdit(address)
        {
            // Creates a tmp address to prevent unwanted two-way binding
            const addressToEdit = JSON.parse(JSON.stringify(address));

            if (addressToEdit.options)
            {
                for (const option of addressToEdit.options)
                {
                    const optionName = this.addressOptionTypeFieldMap[option.typeId];

                    addressToEdit[optionName] = option.value || null;
                }
            }

            return addressToEdit;
        },

        /**
         * Show the delete modal
         * @param address
         */
        showDeleteModal(address)
        {
            this.modalType = "delete";
            this.addressToDelete = address;
            this.updateHeadline();
            this.deleteModal.show();
        },

        /**
         * Delete the address selected before
         */
        deleteAddress()
        {
            this.deleteModalWaiting = true;

            this.$store.dispatch("deleteAddress", { address: this.addressToDelete, addressType: this.addressType })
                .then(
                    response =>
                    {
                        this.closeDeleteModal();
                        this.deleteModalWaiting = false;
                    },
                    error =>
                    {
                        this.deleteModalWaiting = false;
                    }
                );
        },

        /**
         * Close the current create/update address modal
         */
        closeAddressModal()
        {
            this.addressModal.hide();
        },

        /**
         * Close the current delete address modal
         */
        closeDeleteModal()
        {
            this.deleteModal.hide();
        },

        /**
         * Dynamically create the header line in the modal
         */
        updateHeadline()
        {
            let headline;

            if (this.modalType === "initial")
            {
                headline = TranslationService.translate("Ceres::Template.addressInvoiceAddressInitial");
            }
            else if (this.addressType === "2")
            {
                if (this.modalType === "update")
                {
                    headline = TranslationService.translate("Ceres::Template.addressShippingAddressEdit");
                }
                else if (this.modalType === "create")
                {
                    headline = TranslationService.translate("Ceres::Template.addressShippingAddressCreate");
                }
                else
                {
                    headline = TranslationService.translate("Ceres::Template.addressShippingAddressDelete");
                }
            }
            else if (this.modalType === "update")
            {
                headline = TranslationService.translate("Ceres::Template.addressInvoiceAddressEdit");
            }
            else if (this.modalType === "create")
            {
                headline = TranslationService.translate("Ceres::Template.addressInvoiceAddressCreate");
            }
            else
            {
                headline = TranslationService.translate("Ceres::Template.addressInvoiceAddressDelete");
            }

            this.headline = headline;
        },

        /**
         * @param countryId
         * @returns string
         */
        getCountryName(countryId)
        {
            return this.$store.getters.getCountryName(countryId);
        },

        setAddressToEditField({ field, value })
        {
            this.addressToEdit[field] = value;
            this.addressToEdit = Object.assign({}, this.addressToEdit);
        },

        onDropdownClicked(event)
        {
            if (this.isAddressListEmpty || (parseInt(this.addressType) === 2 && this.addressList.length === 1))
            {
                event.preventDefault();
                event.stopPropagation();
                this.showAddModal();
            }
        },

        toggleDropdown(event)
        {
            event.preventDefault();
            event.stopPropagation();
            this.$refs.dropdown.click();
            event.currentTarget.blur();

        }
    },

    filters:
    {
        optionType(selectedAddress, typeId)
        {
            if (selectedAddress && selectedAddress.options)
            {
                for (const optionType of selectedAddress.options)
                {
                    if (optionType.typeId === typeId)
                    {
                        return optionType.value;
                    }
                }
            }

            return "";
        }
    },

    watch:
    {
        isSalutationEnabled(newVal)
        {
            if (!newVal)
            {
                delete this.addressToEdit.gender;
            }
        }
    }
});
